import { createAction, props } from '@ngrx/store';

import { ReportManureSubstancesView, ReportSort } from '../reports/models';
import { Crop, CropVariety, CustomerProgress, SoilAnalysisByCropFieldId } from '../shared/models';

export const ContextChanged = createAction('[App] Context changed');

export const GetDefaultCropYear = createAction('[App] Get default crop year');

export const SetDefaultCropYear = createAction(
  '[App] Set default crop year',
  props<{ cropYear: number }>(),
);

export const GetDefaultSoilType = createAction('[App] Get default soil type');

export const SetDefaultSoilType = createAction(
  '[App] Set default soil type',
  props<{ soilTypeId: number }>(),
);

export const UpsertDefaultSoilType = createAction(
  '[App] Upsert default soil type',
  props<{ soilTypeId: number }>(),
);

export const UpsertDefaultSoilTypeSuccess = createAction('[App] Upsert default soil type Success');

export const SetCropYear = createAction('[App] Set crop year', props<{ cropYear: number }>());

export const CropYearChanged = createAction(
  '[App] Crop year changed',
  props<{ cropYear: number }>(),
);

export const SetAvailableCropYears = createAction(
  '[App] Set available crop year',
  props<{ availableCropYears: number[] }>(),
);

export const GetLatestSoilAnalysisRequest = createAction('[App] Get latest soil analyses request');

export const GetLatestSoilAnalysisSuccess = createAction(
  '[App] Get latest soil analyses success',
  props<{ soilAnalysisGroups: SoilAnalysisByCropFieldId[] }>(),
);

export const LoadCropsRequest = createAction('[App] Load crops request');

export const LoadCropsSuccess = createAction(
  '[App] Load crops success',
  props<{ crops: Crop[] }>(),
);

export const LoadCropVarietiesByCropIdsRequest = createAction(
  '[App] Load crop varieties by list of crop ids request',
  props<{ cropIds: number[] }>(),
);

export const LoadCropVarietiesByCropIdsSuccess = createAction(
  '[App] Load crop varieties by list of crop ids success',
  props<{ cropIds: number[]; cropVarieties: CropVariety[] }>(),
);

export const NavigateToFieldPlan = createAction('[App] Navigate to field plan');

export const GetReportSort = createAction('[App] Get report sort');

export const CloseImportDialog = createAction('[App] Close import dialog');

export const SetReportSort = createAction(
  '[App] Set report sort',
  props<{ reportSort: ReportSort }>(),
);

export const ToggleReportSortOption = createAction('[App] Toggle report sort option');

export const ToggleReportSortDirection = createAction('[App] Toggle report sort direction');

export const SetReportManureSubstancesView = createAction(
  '[App] Set report manure substances view',
  props<{ reportManureSubstancesView: ReportManureSubstancesView }>(),
);

export const LoadCustomerProgress = createAction('[App] Load customer progress');

export const LoadCustomerProgressSuccess = createAction(
  '[App] Load customer progress success',
  props<{ customerProgress: CustomerProgress }>(),
);

export const ToggleCustomerProgressManure = createAction('[App] Toggle customer progress advice');

export const CloseAnimalManureTransportDatepickerDialog = createAction(
  '[App] Close animal manure transport datepicker dialog',
);

export const CloseAnimalManureTransportOverview = createAction(
  '[App] Close animal manure transport overview',
);

export const CloseVzcTransportOverview = createAction('[App] Close vzc transport overview');
